export const FORECAST_COMMENTS_BASE_URL = '/integration.module/excise.tax.forecast';
export const FORECAST_COMMENTS_VALUELISTS_URL = 'ais/valueLists/EXCISE_TAX_FORECAST_REQUESTS';
export const FORECAST_COMMENTS_PAGE_TITLE =
    'Сервис обмена информацией по результатам прогноза налоговых поступлений НДПИ, НДД, Акциза на нефтяное сырье';
export const FORECAST_COMMENTS_ACTION_PANEL_TITLE = 'Сервис отправки ответа с прогнозом поступлений НДПИ, НДД, АС v3';
